import { render } from "./PopupContainer.vue?vue&type=template&id=f1a205e6"
import script from "./PopupContainer.vue?vue&type=script&lang=js"
export * from "./PopupContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__